var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLinkedlnIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6 27.1006V17.8711C26.6 13.3351 25.6235 9.87012 20.3315 9.87012C17.78 9.87012 16.079 11.2561 15.386 12.5791H15.323V10.2796H10.3145V27.1006H15.5435V18.7531C15.5435 16.5481 15.953 14.4376 18.662 14.4376C21.3395 14.4376 21.371 16.9261 21.371 18.8791V27.0691H26.6V27.1006Z",
    fill: "#ED3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1.80957 10.2791H7.03857V27.1001H1.80957V10.2791Z",
    fill: "#ED3E3E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.4239 1.90015C2.7544 1.90015 1.3999 3.25465 1.3999 4.92415C1.3999 6.59365 2.7544 7.97965 4.4239 7.97965C6.0934 7.97965 7.4479 6.59365 7.4479 4.92415C7.4479 3.25465 6.0934 1.90015 4.4239 1.90015Z",
    fill: "#ED3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedlnIcon);
export default __webpack_public_path__ + "static/media/linkedln_icon.d204ca85ec845b544552bbb599281577.svg";
export { ForwardRef as ReactComponent };